// src/utils/upForGrabsFeed.js
// Feed post copy for Up For Grabs open houses. Pure text builders; the
// Firestore glue in firebasefunctions.js decides when to create/update the
// post. House rules: displayed dates MM/DD/YYYY, no em dashes.
import { mmddyyyy } from "./checkinSorting";

// "13:05" -> "1:05pm". Empty/junk input -> "".
export function timeText(t) {
  const [hStr, mStr] = String(t || "").split(":");
  const h = Number(hStr);
  if (!Number.isFinite(h) || hStr === "") return "";
  const period = h >= 12 ? "pm" : "am";
  const h12 = ((h + 11) % 12) + 1;
  return `${h12}:${(mStr || "00").padStart(2, "0")}${period}`;
}

const shortAddress = (opp) =>
  String(opp?.propertyAddress || "").split(",")[0].trim() || "a listing";

export function buildUpForGrabsPostText(opp) {
  const lines = [`Open house up for grabs: ${shortAddress(opp)}.`];
  const timing = String(opp?.suggestedTiming || "").trim();
  if (timing) lines.push(`Suggested timing: ${timing}.`);
  lines.push("Want to host? Request it on the Up For Grabs board (Open Houses page).");
  return lines.join("\n");
}

export function buildUpForGrabsFilledText(opp, winner) {
  const when = [
    mmddyyyy(winner?.proposedDate),
    [timeText(winner?.proposedStartTime), timeText(winner?.proposedEndTime)]
      .filter(Boolean)
      .join(" to "),
  ]
    .filter(Boolean)
    .join(", ");
  const host = String(winner?.agentName || "").trim() || "a teammate";
  // Names like "Jamie R." already end the sentence; don't double the period.
  const end = host.endsWith(".") ? "" : ".";
  return `Filled. The open house at ${shortAddress(opp)}${
    when ? ` on ${when}` : ""
  } will be hosted by ${host}${end}`;
}

export function buildUpForGrabsCancelledText(opp) {
  return `No longer up for grabs: ${shortAddress(opp)}. This open house is no longer available.`;
}
